import type { FactArticle, Verdict } from "@/mocks/articles";
import { categoryName, verdictMeta } from "@/mocks/articles";
import { Link } from "react-router-dom";

// 真伪结果徽标：实锤(绿) / 存疑(沙金) / 不实(信号红)
export function VerdictBadge({
  verdict,
  size = "md",
}: {
  verdict: Verdict;
  size?: "sm" | "md";
}) {
  const meta = verdictMeta[verdict];
  const box =
    size === "sm"
      ? "px-2 py-0.5 text-[11px] gap-1"
      : "px-2.5 py-1 text-xs gap-1.5";
  return (
    <span
      className={`inline-flex items-center rounded-full border font-medium whitespace-nowrap ${meta.tone} ${box}`}
    >
      <span
        className={`inline-block rounded-full bg-current ${
          size === "sm" ? "w-1.5 h-1.5" : "w-2 h-2"
        }`}
      />
      {meta.label}
    </span>
  );
}

// 时间 + 阅读时长元信息
export function CardMeta({
  date,
  minutes,
  heat,
}: {
  date: string;
  minutes: number;
  heat?: number;
}) {
  return (
    <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-600">
      <span className="inline-flex items-center gap-1">
        <i className="ri-calendar-line text-sm" />
        {date}
      </span>
      <span className="inline-flex items-center gap-1">
        <i className="ri-time-line text-sm" />
        约 {minutes} 分钟
      </span>
      {heat !== undefined && (
        <span className="inline-flex items-center gap-1">
          <i className="ri-fire-line text-primary-600 text-sm" />
          {(heat / 1000).toFixed(1)}k
        </span>
      )}
    </div>
  );
}

export function CategoryPill({ category }: { category: string }) {
  return (
    <span className="inline-flex items-center rounded-md bg-secondary-100 px-2 py-0.5 text-[11px] font-medium text-secondary-900 whitespace-nowrap">
      {categoryName(category)}
    </span>
  );
}

// 通用事件卡片（纵向大卡）
export function ArticleCard({ article }: { article: FactArticle }) {
  return (
    <Link
      to={`/article/${article.slug}`}
      className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-background-300"
    >
      <div className="relative aspect-[4/3] w-full overflow-hidden bg-background-100">
        <img
          src={article.cover}
          alt={article.title}
          title={article.title}
          loading="lazy"
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
        />
        <div className="absolute left-3 top-3">
          <VerdictBadge verdict={article.verdict} size="sm" />
        </div>
      </div>
      <div className="flex flex-1 flex-col gap-3 p-4 md:p-5">
        <div className="flex items-center justify-between gap-2">
          <CategoryPill category={article.category} />
        </div>
        <h3 className="line-clamp-2 font-heading text-base font-bold leading-snug text-foreground-950 md:text-lg">
          {article.title}
        </h3>
        <p className="line-clamp-2 text-sm leading-relaxed text-foreground-700">
          {article.summary}
        </p>
        <div className="mt-auto flex items-center justify-between border-t border-background-100 pt-3">
          <CardMeta date={article.date} minutes={article.readMinutes} heat={article.heat} />
          <span className="inline-flex shrink-0 items-center gap-1 text-sm font-medium text-primary-700 transition-colors group-hover:text-primary-600">
            解析
            <i className="ri-arrow-right-line" />
          </span>
        </div>
      </div>
    </Link>
  );
}